import { formatPrice } from '@mssgme/shared';

// TODO: redo, Trans component do not support options
export default (value, format, locale, options) => {
    if (format === 'currency') {
        if (typeof value === 'number') {
            return formatPrice(value, options.currency, locale);
        } else {
            return formatPrice(value.amount, value.currency, locale);
        }
    }
};
